import { render, staticRenderFns } from "./SupplyFolder.vue?vue&type=template&id=1ec8a5c4&scoped=true&"
import script from "./SupplyFolder.vue?vue&type=script&lang=js&"
export * from "./SupplyFolder.vue?vue&type=script&lang=js&"
import style0 from "./SupplyFolder.vue?vue&type=style&index=0&id=1ec8a5c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec8a5c4",
  null
  
)

export default component.exports